import { Store } from 'vuex'

import Vue from 'vue'
import website from './modules/website'
import cart from './modules/cart'
import payment from './modules/payment'
import user from './modules/user'
import registration from './modules/registration'
import configuration from './modules/configuration'
import shop from './modules/shop'

import selection from './modules/selection'

export default function buildStore (vuexSession, vuexLogger) {
  const plugins = [vuexSession.plugin]
  if (vuexLogger) {
    plugins.push(vuexLogger)
  }

  const strictMode = Vue.prototype.$container.config.env === 'development'

  return new Store({
    actions: {
      clearOnConfirmation ({ commit }) {
        commit('cart/RESET')
        commit('payment/RESET')
        commit('registration/RESET')
      }
    },
    modules: {
      website,
      cart,
      payment,
      user,
      registration,
      selection,
      configuration,
      shop
    },
    mutations: {
      RESTORE_MUTATION: vuexSession.RESTORE_MUTATION
    },
    strict: strictMode,
    plugins: plugins
  })
}



// WEBPACK FOOTER //
// ./src/store/index.js